// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SL_y","tabsBox":"styles_tabsBox__xtJlF","createButton":"styles_createButton__JxEKg"};